/* eslint-disable no-undef */
export default {
	name: "add-update-customer-group-pricing-for-zone",
	props:{
		productId:{
			default: null
		},
		companyId:{
			default: null
		}
	},
	data() {
		return {
            shippingAddresses: [],
            existingShippingAddressPricing: [],
			customerGroupPricingDelivery: {
				customerId:{
					value: null,
					hasError: false,
					errorMessage: null
				},
				discountAmount:{
					value: 0,
					hasError: false,
					errorMessage: null
				},
				products:{
					hasError: false,
					errorMessage: null
				},
				selectedProducts: [],
				shippingAddresses:{
					hasError: false,
					errorMessage: null
				},
				selectedShippingAddresses: [],
				effectiveDate:{
					value: new Date(),
					hasError: false,
					errorMessage: null
				}
			},
			customerId: null,
			pricingUpdated: false,
			products: [],
			companies: [],
			loading: false,
			isUpdate: false,
			resetPassword: false,
			errorModal:{
				modalHeading: "Error",
				elementId: "productPricingDeliveryModalError",
				modalMessage: "",
				showModal: false
			},
			successModal:{
				modalHeading: "Success",
				elementId: "productPricingDeliveryModalSuccess",
				modalMessage: "",
				showModal: false
			},
			initialiseDate: true
		};
	},
	methods: {
        getCompanyShippingAddresses(){
            if(!this.customerGroupPricingDelivery.customerId.value) return;
            
            let request = {
                companyId: this.customerGroupPricingDelivery.customerId.value,
                isActive: true,
                pageNumber: 1,
                pageSize: 5000
            };
            
            customerService.getCompanyShippingAddresses(request).then(
                successResponse => {
                    let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
                    if(isSuccess){
                        this.shippingAddresses = successResponse.data.result;
                        this.shippingAddresses = dataTableHelper.castFieldValues(this.shippingAddresses);
                        
                        // Initialize selection state for each shipping address
                        for(let i = 0; i < this.shippingAddresses.length; i++){
                            this.shippingAddresses[i].selected = false;
                        }
                        
                        // If in edit mode, mark previously selected shipping addresses
                        // if(this.isUpdate) {
                        //     this.markSelectedShippingAddresses();
                        // }
                        this.markSelectedShippingAddresses();
                        
                        this.pricingUpdated = true;
                    }
                },
                errorResponse => {
                    console.log("error", errorResponse);
                    this.loading = false;
                    apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
                }
            );
        },
		getCustomerGroupPricingDelivery(){
			this.loading = true;
			let request = {
				//productId: this.productId,
				companyId: this.companyId === null || this.companyId === "" ? this.customerGroupPricingDelivery.customerId.value : this.companyId,
				isActive: true
			}
			
			this.customerId = this.companyId;
			productService.getCompanyShippingAddressPrices(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						this.existingShippingAddressPricing = successResponse.data.result;
						
						// If there's existing data, extract the discount amount
						if(successResponse.data.result && successResponse.data.result.length > 0){
							this.customerGroupPricingDelivery.discountAmount.value = successResponse.data.result[0].discountAmount || 0;
						}
						
						// Fetch shipping addresses for the company
						this.getCompanyShippingAddresses();
						
						// Mark the selected product if products are already loaded
						if(this.products && this.products.length > 0){
							this.markSelectedProducts();
						}
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getCompanies(){
			let request = {
				isActive: true,
				pageNumber: 1,
				pageSize: 5000,
				isDeliveryCompany: true,
				isCollectionCompany: false,
				isExTankCompany: false,
			};
			customerService.getCompanies(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess) {
						this.companies = successResponse.data.result;
						this.companies = $.map(this.companies,
							function (obj) {
								obj.id = obj.id || obj.companyId;
								obj.text = obj.text || obj.registeredCompanyName;
								return obj;
							});
						// if(this.customerId !== null){
						// 	this.customerGroupPricingDelivery.customerId.value = this.customerId;
						// }
						this.customerGroupPricingDelivery.customerId.value = parseInt(this.companyId) || null;
                        // If in edit mode, mark previously selected products
                        if(this.isUpdate && this.productId) {
                            this.markSelectedProducts();
                        }
						console.log("customerGroupPricingDelivery.customerId", this.customerGroupPricingDelivery.customerId.value);
						console.log("companies", this.companies);
					}
				},
				errorResponse => {
					console.log("error", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getProducts(){
			let request = {
				isActive: true,
				allowDelivery: true,
                companyId: this.customerGroupPricingDelivery.customerId.value,
			};
			productService.getProductsByCustomerProductType(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						this.products = successResponse.data.result;
						this.products = dataTableHelper.castFieldValues(this.products);
						this.products = $.map(this.products,
							function (obj) {
								obj.id = obj.id || obj.productId;
								obj.text = obj.text || obj.name;
								obj.selected = false; // Initialize selection state
								obj.basePrice = obj.basePrice || 0; // Ensure base price exists
								return obj;
							});

                        // if(this.isUpdate) {
                        // 	this.markSelectedProducts();
                        // }
                        this.markSelectedProducts();
                        // Mark the selected product if products are already loaded
                        // if(this.products && this.products.length > 0){
                        //     this.markSelectedProducts();
                        // }
						// // If in edit mode, mark previously selected products
						// if(this.isUpdate && this.productId) {
						// 	this.markSelectedProducts();
						// }
					}
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},

		onDiscountAmountChange(){
			console.log("discount amount changed");
			// Force reactivity update for the table
			this.$forceUpdate();
		},
		onShippingAddressSelectionChange(address){
			console.log("shipping address selection changed", address);
			
			// Clear shipping address error messages
			this.customerGroupPricingDelivery.shippingAddresses.hasError = false;
			this.customerGroupPricingDelivery.shippingAddresses.errorMessage = null;
			
			if(address.selected) {
				// Add to selected shipping addresses if not already there
				if(!this.customerGroupPricingDelivery.selectedShippingAddresses.find(a => a.companyAddressId === address.companyAddressId)) {
					this.customerGroupPricingDelivery.selectedShippingAddresses.push(address);
				}
			} else {
				// Remove from selected shipping addresses
				this.customerGroupPricingDelivery.selectedShippingAddresses = this.customerGroupPricingDelivery.selectedShippingAddresses.filter(a => a.companyAddressId !== address.companyAddressId);
			}
			
			console.log("selectedShippingAddresses", this.customerGroupPricingDelivery.selectedShippingAddresses);
			this.pricingUpdated = true;
		},
		onProductSelectionChange(product){
			console.log("product selection changed", product);
			
			// Clear product error messages
			this.customerGroupPricingDelivery.products.hasError = false;
			this.customerGroupPricingDelivery.products.errorMessage = null;
			
			if(product.selected) {
				// Add to selected products if not already there
				if(!this.customerGroupPricingDelivery.selectedProducts.find(p => p.productId === product.productId)) {
					this.customerGroupPricingDelivery.selectedProducts.push(product);
				}
			} else {
				// Remove from selected products
				this.customerGroupPricingDelivery.selectedProducts = this.customerGroupPricingDelivery.selectedProducts.filter(p => p.productId !== product.productId);
			}
			
			console.log("selectedProducts", this.customerGroupPricingDelivery.selectedProducts);
		},
		calculatePriceAfterDiscount(basePrice){
			if(!basePrice) return 0;
			let discountAmount = this.customerGroupPricingDelivery.discountAmount.value || 0;
			return Math.max(0, basePrice - discountAmount);
		},
		markSelectedProducts(){
            this.customerGroupPricingDelivery.selectedShippingAddresses = [];
			// Mark products as selected if they were previously selected (edit mode)
            console.log("shippingAddressesWithPricing", this.existingShippingAddressPricing);
			for(let i = 0; i < this.products.length; i++){
                // for(let j = 0; j < this.shippingAddressesWithPricing.length; j++){
                //     if(this.shippingAddressesWithPricing[j].productId === this.products[i].productId){
                //         this.products[i].selected = true;
                //         this.customerGroupPricingDelivery.selectedProducts.push(this.products[i]);
                //         break;
                //     }
                // }
                for(let j = 0; j < this.existingShippingAddressPricing.length; j++){
                    this.products[i].selected = false;
                    if(this.existingShippingAddressPricing[j].productId === this.products[i].productId){
                        this.products[i].selected = true;
                        // check to see if product is already in selectedProducts
                        if(!this.customerGroupPricingDelivery.selectedProducts.find(p => p.productId === this.products[i].productId)) {
                            this.customerGroupPricingDelivery.selectedProducts.push(this.products[i]);
                        }
                        break;
                    }
                }
				// if(this.products[i].productId === this.productId){
				// 	this.products[i].selected = true;
				// 	this.customerGroupPricingDelivery.selectedProducts.push(this.products[i]);
				// 	break;
				// }
			}
            console.log("products", this.products);
		},
		markSelectedShippingAddresses(){
            this.customerGroupPricingDelivery.selectedShippingAddresses = [];
			// Mark shipping addresses as selected if they were previously selected (edit mode)
			if(!this.existingShippingAddressPricing || this.existingShippingAddressPricing.length === 0) return;
			
			for(let i = 0; i < this.shippingAddresses.length; i++){
                this.shippingAddresses[i].selected = false;
				for(let j = 0; j < this.existingShippingAddressPricing.length; j++){
					if(this.existingShippingAddressPricing[j].companyAddressId === this.shippingAddresses[i].companyAddressId){
						this.shippingAddresses[i].selected = true;
                        // check to see if address is already in selectedShippingAddresses
                        if(!this.customerGroupPricingDelivery.selectedShippingAddresses.find(a => a.companyAddressId === this.shippingAddresses[i].companyAddressId)) {
						    this.customerGroupPricingDelivery.selectedShippingAddresses.push(this.shippingAddresses[i]);
                        }
						break;
					}
				}
			}
			console.log("selectedShippingAddresses after marking", this.customerGroupPricingDelivery.selectedShippingAddresses);
		},
		onCompanySelect(company){
			if(this.customerGroupPricingDelivery.customerId.value !== company.id){
				this.customerGroupPricingDelivery.customerId.value = company.id;
				// Clear previous selections
				this.customerGroupPricingDelivery.selectedShippingAddresses = [];
				// Fetch shipping addresses for the new company
                this.getProducts();
                this.getCustomerGroupPricingDelivery();
				this.getCompanyShippingAddresses();
			}
		},

		onEffectiveDateSelect(date){
			this.customerGroupPricingDelivery.effectiveDate.value = date;
			this.initialiseDate = false;
		},

		onBackClick(){
			this.$router.go(-1);
		},
		successModalOkClicked(){
			this.successModal = {
				modalHeading: "Success",
				elementId: "productPricingDeliveryModalSuccess",
				modalMessage: "",
				showModal: false
			};
			this.clearModel();
			if(this.isUpdate){
				this.$router.go(-1);
			}
		},
		errorModalOkClicked(){
			this.errorModal = {
				modalHeading: "Error",
				elementId: "productPricingDeliveryModalError",
				modalMessage: "",
				showModal: false
			};
		},
		saveDeliveryPricing(){
			// Validate selected products
			if(this.customerGroupPricingDelivery.selectedProducts.length === 0){
				this.customerGroupPricingDelivery.products.hasError = true;
				this.customerGroupPricingDelivery.products.errorMessage = "Please select at least one product";
				return;
			}
			
			// Validate selected shipping addresses
			if(this.customerGroupPricingDelivery.selectedShippingAddresses.length === 0){
				this.customerGroupPricingDelivery.shippingAddresses.hasError = true;
				this.customerGroupPricingDelivery.shippingAddresses.errorMessage = "Please select at least one shipping address";
				return;
			}
			
			this.loading = true;
			var productCustomerShippingAddressPrices = [];
			
			// Process each selected product and shipping address combination
            console.log("selectedProducts", this.customerGroupPricingDelivery.selectedProducts);
            console.log("selectedShippingAddresses", this.customerGroupPricingDelivery.selectedShippingAddresses);
			for(let selectedProduct of this.customerGroupPricingDelivery.selectedProducts){
				for(let selectedAddress of this.customerGroupPricingDelivery.selectedShippingAddresses){
					// Check if this combination already exists in existing data
					let existingEntry = this.existingShippingAddressPricing.find(entry => 
						entry.productId === selectedProduct.productId && 
						entry.companyAddressId === selectedAddress.companyAddressId
					);
					
					var productCustomerShippingAddressPrice = {
						productId: selectedProduct.productId,
						companyShippingAddressPriceId: existingEntry ? existingEntry.companyShippingAddressPriceId : 0,
						companyAddressId: selectedAddress.companyAddressId,
						discountAmount: this.customerGroupPricingDelivery.discountAmount.value || 0,
						isActive: true
					};
					productCustomerShippingAddressPrices.push(productCustomerShippingAddressPrice);
				}
			}
			
			let request = {
				companyId: this.customerGroupPricingDelivery.customerId.value === null ? 0 : this.customerGroupPricingDelivery.customerId.value,
				discountAmount: this.customerGroupPricingDelivery.discountAmount.value || 0,
				selectedProducts: this.customerGroupPricingDelivery.selectedProducts.map(p => p.productId),
				selectedShippingAddresses: this.customerGroupPricingDelivery.selectedShippingAddresses.map(a => a.companyAddressId),
				productCustomerShippingAddressPrices: productCustomerShippingAddressPrices,
				effectiveDate: this.customerGroupPricingDelivery.effectiveDate.value
			};
			productService.addOrUpdateCompanyShippingAddressPrice(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						if(successResponse.data.customerShippingAddressPriceValidationResponse.valuesAreValid){
							this.successModal.showModal = true;
							this.successModal.modalMessage = "Pricing Saved Successfully";
						}
						else{
							if(successResponse.data.customerShippingAddressPriceValidationResponse.productValidationResponse){
								this.customerGroupPricingDelivery.products.errorMessage = successResponse.data.customerShippingAddressPriceValidationResponse.productValidationResponse.message;
								this.customerGroupPricingDelivery.products.hasError = successResponse.data.customerShippingAddressPriceValidationResponse.productValidationResponse.hasError;
							}

							if(successResponse.data.customerShippingAddressPriceValidationResponse.companyValidationResponse){
								this.customerGroupPricingDelivery.customerId.errorMessage = successResponse.data.customerShippingAddressPriceValidationResponse.companyValidationResponse.message;
								this.customerGroupPricingDelivery.customerId.hasError = successResponse.data.customerShippingAddressPriceValidationResponse.companyValidationResponse.hasError;
							}
							
							if(successResponse.data.customerShippingAddressPriceValidationResponse.effectiveDateValidationResponse){
								this.customerGroupPricingDelivery.effectiveDate.errorMessage = successResponse.data.customerShippingAddressPriceValidationResponse.effectiveDateValidationResponse.message;
								this.customerGroupPricingDelivery.effectiveDate.hasError = successResponse.data.customerShippingAddressPriceValidationResponse.effectiveDateValidationResponse.hasError;
							}

							if(successResponse.data.customerShippingAddressPriceValidationResponse.shippingAddressValidationResponse){
								this.customerGroupPricingDelivery.shippingAddresses.errorMessage = successResponse.data.customerShippingAddressPriceValidationResponse.shippingAddressValidationResponse.message;
								this.customerGroupPricingDelivery.shippingAddresses.hasError = successResponse.data.customerShippingAddressPriceValidationResponse.shippingAddressValidationResponse.hasError;
							}
							
							if(successResponse.data.customerShippingAddressPriceValidationResponse.discountAmountValidationResponse){
								this.customerGroupPricingDelivery.discountAmount.errorMessage = successResponse.data.customerShippingAddressPriceValidationResponse.discountAmountValidationResponse.message;
								this.customerGroupPricingDelivery.discountAmount.hasError = successResponse.data.customerShippingAddressPriceValidationResponse.discountAmountValidationResponse.hasError;
							}
						}
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		clearModel(){
			this.customerGroupPricingDelivery = {
				customerId:{
					value: null,
					hasError: false,
					errorMessage: null
				},
				discountAmount:{
					value: 0,
					hasError: false,
					errorMessage: null
				},
				products:{
					hasError: false,
					errorMessage: null
				},
				selectedProducts: [],
				shippingAddresses:{
					hasError: false,
					errorMessage: null
				},
				selectedShippingAddresses: [],
				effectiveDate:{
					value: new Date(),
					hasError: false,
					errorMessage: null
				}
			};
			this.customerId = null;
			this.pricingUpdated = false;
			this.shippingAddresses = [];
			this.existingShippingAddressPricing = [];
			
			// Clear product selections
			for(let i = 0; i < this.products.length; i++){
				this.products[i].selected = false;
			}
		},
		setBreadcrumbs() {
			var pageTitle = "Add Customer Group Pricing For Zone";
			if((this.productId !== null && this.companyId !== null) && (this.productId > 0 && this.companyId > 0)){
				pageTitle = "Edit Customer Group Pricing For Zone";
			}
			storeState.setPageTitleAction(pageTitle);
			breadcrumbsStoreState.updateBreadcrumbs(this.$route, pageTitle);
		}
	},
	mounted: function () {
		this.setBreadcrumbs();
		//this.getProducts();
		this.getCompanies();
		
		// If we have a companyId prop, fetch shipping addresses
		if(this.companyId && this.companyId > 0){
			this.customerGroupPricingDelivery.customerId.value = this.companyId;
            this.getProducts();
			this.getCompanyShippingAddresses();
		}
	},
	watch: {
		companyId: {
			handler: function () {
				if (this.companyId !== null && this.companyId > 0) {
					this.isUpdate = true;
					this.customerGroupPricingDelivery.customerId.value = this.companyId;
					this.getCustomerGroupPricingDelivery();
				}
				else{
					this.isUpdate = false;
				}
			},
			immediate: true,
			deep: true
		}
	}
};